import React from 'react'

function Categories() {
  const categories = [
    {
      title: 'Pães',
      img: 'https://static.lumi.new/46/46ebd18fe118cfee34a22271a7ba7204.png',
      items: ['Pão de forma macio', 'Pão artesanal rústico', 'Pãezinhos de café da manhã'],
    },
    {
      title: 'Pizzas',
      img: 'https://static.lumi.new/02/0221a7a8b38c7ba1057027b3395b2b22.png',
      items: ['Pizza de massa fina', 'Pizza de liquidificador', 'Pizza recheada'],
    },
    {
      title: 'Croissants',
      img: 'https://static.lumi.new/97/97303ac29be6410a9e1fb7e887dca218.png',
      items: ['Croissant folhado', 'Croissant de chocolate', 'Mini croissants'],
    },
    {
      title: 'Sobremesas',
      img: 'https://static.lumi.new/3c/3cde2bfc91260331986e4307672ea956.png',
      items: ['Bolos sem açúcar', 'Tortas cremosas', 'Sobremesas geladas'],
    },
    {
      title: 'Receitas do Dia',
      img: 'https://static.lumi.new/95/95a78be57ee5a7fcd0ea5ee66e280dca.png',
      items: ['Sugestão diária', 'Cardápio da semana', 'Receitas sazonais'],
    },
    {
      title: 'Bases Culinárias',
      img: 'https://static.lumi.new/07/07cfa244c9f2d531232847fa098cac86.png',
      items: ['Massas base', 'Farinhas e misturas', 'Fermentos naturais'],
    },
  ]

  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="text-center mb-14 animate-fade-up">
          <p className="text-[#D9891B] font-semibold uppercase tracking-wide text-sm mb-3">Explore o app</p>
          <h2 className="font-display text-[#49352B] text-3xl md:text-5xl font-bold">
            Mais de 400 receitas em 6 categorias
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 md:grid-rows-2 auto-rows-fr">
          {categories.map((cat, i) => (
            <div
              key={i}
              className={`group bg-[#FCFAF5] rounded-[20px] overflow-hidden border border-[#EBD9C3] shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 animate-fade-up flex flex-col ${i === 0 ? 'md:row-span-2' : ''}`}
            >
              <div className={`overflow-hidden ${i === 0 ? 'h-72 md:h-full md:min-h-[420px]' : 'h-56'}`}>
                <img
                  src={cat.img}
                  alt={cat.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-7">
                <h3 className="font-display text-xl font-bold text-[#49352B] mb-4">{cat.title}</h3>
                <ul className="space-y-2">
                  {cat.items.map((item, j) => (
                    <li key={j} className="text-[#49352B]/70 text-sm flex items-center gap-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#D9891B]" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Categories
